/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { DownloadBusinessObjectDataStorageFileSingleInitiationRequest } from '../model/downloadBusinessObjectDataStorageFileSingleInitiationRequest';
import { DownloadBusinessObjectDataStorageFileSingleInitiationResponse } from '../model/downloadBusinessObjectDataStorageFileSingleInitiationResponse';
import { DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest } from '../model/downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest';
import { DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationResponse } from '../model/downloadBusinessObjectDefinitionSampleDataFileSingleInitiationResponse';
import { DownloadSingleInitiationResponse } from '../model/downloadSingleInitiationResponse';
import { ErrorInformation } from '../model/errorInformation';
import { UploadBusinessObjectDefinitionSampleDataFileInitiationRequest } from '../model/uploadBusinessObjectDefinitionSampleDataFileInitiationRequest';
import { UploadBusinessObjectDefinitionSampleDataFileInitiationResponse } from '../model/uploadBusinessObjectDefinitionSampleDataFileInitiationResponse';
import { UploadSingleCredentialExtensionResponse } from '../model/uploadSingleCredentialExtensionResponse';
import { UploadSingleInitiationRequest } from '../model/uploadSingleInitiationRequest';
import { UploadSingleInitiationResponse } from '../model/uploadSingleInitiationResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class UploadAndDownloadService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * extendUploadSingleCredentials
     * Extends the credentials for a previously initiated upload. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace the namespace.
     * @param businessObjectDefinitionName the business object definition name.
     * @param businessObjectFormatUsage the business object format usage.
     * @param businessObjectFormatFileType the business object format file type.
     * @param businessObjectFormatVersion the business object format version.
     * @param partitionValue the partition value.
     * @param businessObjectDataVersion the business object data version.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadandDownloadExtendUploadSingleCredentials(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe?: 'body', reportProgress?: boolean): Observable<UploadSingleCredentialExtensionResponse>;
    public uploadandDownloadExtendUploadSingleCredentials(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadSingleCredentialExtensionResponse>>;
    public uploadandDownloadExtendUploadSingleCredentials(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadSingleCredentialExtensionResponse>>;
    public uploadandDownloadExtendUploadSingleCredentials(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }
        if (partitionValue === null || partitionValue === undefined) {
            throw new Error('Required parameter partitionValue was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }
        if (businessObjectDataVersion === null || businessObjectDataVersion === undefined) {
            throw new Error('Required parameter businessObjectDataVersion was null or undefined when calling uploadandDownloadExtendUploadSingleCredentials.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<UploadSingleCredentialExtensionResponse>(`${this.configuration.basePath}/upload/single/credential/extension/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/partitionValues/${encodeURIComponent(String(partitionValue))}/businessObjectDataVersions/${encodeURIComponent(String(businessObjectDataVersion))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * initiateDownloadSingle
     * Initiates a download of a single file. &lt;p&gt;Requires READ permission on namespace&lt;/p&gt;
     * @param namespace the namespace.
     * @param businessObjectDefinitionName the business object definition name.
     * @param businessObjectFormatUsage the business object format usage.
     * @param businessObjectFormatFileType the business object format file type.
     * @param businessObjectFormatVersion the business object format version.
     * @param partitionValue the partition value.
     * @param businessObjectDataVersion the business object data version.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadandDownloadInitiateDownloadSingle(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe?: 'body', reportProgress?: boolean): Observable<DownloadSingleInitiationResponse>;
    public uploadandDownloadInitiateDownloadSingle(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DownloadSingleInitiationResponse>>;
    public uploadandDownloadInitiateDownloadSingle(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DownloadSingleInitiationResponse>>;
    public uploadandDownloadInitiateDownloadSingle(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, businessObjectFormatVersion: number, partitionValue: string, businessObjectDataVersion: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }
        if (businessObjectFormatVersion === null || businessObjectFormatVersion === undefined) {
            throw new Error('Required parameter businessObjectFormatVersion was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }
        if (partitionValue === null || partitionValue === undefined) {
            throw new Error('Required parameter partitionValue was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }
        if (businessObjectDataVersion === null || businessObjectDataVersion === undefined) {
            throw new Error('Required parameter businessObjectDataVersion was null or undefined when calling uploadandDownloadInitiateDownloadSingle.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<DownloadSingleInitiationResponse>(`${this.configuration.basePath}/download/single/initiation/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/businessObjectFormatVersions/${encodeURIComponent(String(businessObjectFormatVersion))}/partitionValues/${encodeURIComponent(String(partitionValue))}/businessObjectDataVersions/${encodeURIComponent(String(businessObjectDataVersion))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * initiateDownloadSingleBusinessObjectDataStorageFile
     * Download a single business object data storage file
     * @param downloadBusinessObjectDataStorageFileSingleInitiationRequest the download request for single business object data storage file
     * @param preSignedUrlDurationSeconds the duration in seconds for which pre-signed URL should be valid
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadandDownloadInitiateDownloadSingleBusinessObjectDataStorageFile(downloadBusinessObjectDataStorageFileSingleInitiationRequest: DownloadBusinessObjectDataStorageFileSingleInitiationRequest, preSignedUrlDurationSeconds?: number, observe?: 'body', reportProgress?: boolean): Observable<DownloadBusinessObjectDataStorageFileSingleInitiationResponse>;
    public uploadandDownloadInitiateDownloadSingleBusinessObjectDataStorageFile(downloadBusinessObjectDataStorageFileSingleInitiationRequest: DownloadBusinessObjectDataStorageFileSingleInitiationRequest, preSignedUrlDurationSeconds?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DownloadBusinessObjectDataStorageFileSingleInitiationResponse>>;
    public uploadandDownloadInitiateDownloadSingleBusinessObjectDataStorageFile(downloadBusinessObjectDataStorageFileSingleInitiationRequest: DownloadBusinessObjectDataStorageFileSingleInitiationRequest, preSignedUrlDurationSeconds?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DownloadBusinessObjectDataStorageFileSingleInitiationResponse>>;
    public uploadandDownloadInitiateDownloadSingleBusinessObjectDataStorageFile(downloadBusinessObjectDataStorageFileSingleInitiationRequest: DownloadBusinessObjectDataStorageFileSingleInitiationRequest, preSignedUrlDurationSeconds?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (downloadBusinessObjectDataStorageFileSingleInitiationRequest === null || downloadBusinessObjectDataStorageFileSingleInitiationRequest === undefined) {
            throw new Error('Required parameter downloadBusinessObjectDataStorageFileSingleInitiationRequest was null or undefined when calling uploadandDownloadInitiateDownloadSingleBusinessObjectDataStorageFile.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (preSignedUrlDurationSeconds !== undefined && preSignedUrlDurationSeconds !== null) {
            queryParameters = queryParameters.set('preSignedUrlDurationSeconds', <any>preSignedUrlDurationSeconds);
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DownloadBusinessObjectDataStorageFileSingleInitiationResponse>(`${this.configuration.basePath}/download/businessObjectDataStorageFile/single/initiation`,
            downloadBusinessObjectDataStorageFileSingleInitiationRequest,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * initiateDownloadSingleSampleFile
     * Download a single business object definition sample file
     * @param downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadandDownloadInitiateDownloadSingleSampleFile(downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest: DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest, observe?: 'body', reportProgress?: boolean): Observable<DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationResponse>;
    public uploadandDownloadInitiateDownloadSingleSampleFile(downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest: DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationResponse>>;
    public uploadandDownloadInitiateDownloadSingleSampleFile(downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest: DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationResponse>>;
    public uploadandDownloadInitiateDownloadSingleSampleFile(downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest: DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest === null || downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest === undefined) {
            throw new Error('Required parameter downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest was null or undefined when calling uploadandDownloadInitiateDownloadSingleSampleFile.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<DownloadBusinessObjectDefinitionSampleDataFileSingleInitiationResponse>(`${this.configuration.basePath}/download/businessObjectDefinitionSampleDataFile/single/initiation`,
            downloadBusinessObjectDefinitionSampleDataFileSingleInitiationRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * initiateUploadSampleFile
     * Provide the location and credentials prior to upload a Sample Data file &lt;p&gt;Requires WRITE or WRITE_DESCRIPTIVE_CONTENT permission on namespace&lt;/p&gt;
     * @param uploadBusinessObjectDefinitionSampleDataFileInitiationRequest request to upload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadandDownloadInitiateUploadSampleFile(uploadBusinessObjectDefinitionSampleDataFileInitiationRequest: UploadBusinessObjectDefinitionSampleDataFileInitiationRequest, observe?: 'body', reportProgress?: boolean): Observable<UploadBusinessObjectDefinitionSampleDataFileInitiationResponse>;
    public uploadandDownloadInitiateUploadSampleFile(uploadBusinessObjectDefinitionSampleDataFileInitiationRequest: UploadBusinessObjectDefinitionSampleDataFileInitiationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadBusinessObjectDefinitionSampleDataFileInitiationResponse>>;
    public uploadandDownloadInitiateUploadSampleFile(uploadBusinessObjectDefinitionSampleDataFileInitiationRequest: UploadBusinessObjectDefinitionSampleDataFileInitiationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadBusinessObjectDefinitionSampleDataFileInitiationResponse>>;
    public uploadandDownloadInitiateUploadSampleFile(uploadBusinessObjectDefinitionSampleDataFileInitiationRequest: UploadBusinessObjectDefinitionSampleDataFileInitiationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (uploadBusinessObjectDefinitionSampleDataFileInitiationRequest === null || uploadBusinessObjectDefinitionSampleDataFileInitiationRequest === undefined) {
            throw new Error('Required parameter uploadBusinessObjectDefinitionSampleDataFileInitiationRequest was null or undefined when calling uploadandDownloadInitiateUploadSampleFile.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UploadBusinessObjectDefinitionSampleDataFileInitiationResponse>(`${this.configuration.basePath}/upload/businessObjectDefinitionSampleDataFile/initiation`,
            uploadBusinessObjectDefinitionSampleDataFileInitiationRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * initiateUploadSingle
     * Initiates a single file upload capability by creating the relative business object data instance in UPLOADING state and allowing write access to a specific location in S3_MANAGED_LOADING_DOCK storage. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param uploadSingleInitiationRequest the information needed to initiate a file upload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadandDownloadInitiateUploadSingle(uploadSingleInitiationRequest: UploadSingleInitiationRequest, observe?: 'body', reportProgress?: boolean): Observable<UploadSingleInitiationResponse>;
    public uploadandDownloadInitiateUploadSingle(uploadSingleInitiationRequest: UploadSingleInitiationRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UploadSingleInitiationResponse>>;
    public uploadandDownloadInitiateUploadSingle(uploadSingleInitiationRequest: UploadSingleInitiationRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UploadSingleInitiationResponse>>;
    public uploadandDownloadInitiateUploadSingle(uploadSingleInitiationRequest: UploadSingleInitiationRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (uploadSingleInitiationRequest === null || uploadSingleInitiationRequest === undefined) {
            throw new Error('Required parameter uploadSingleInitiationRequest was null or undefined when calling uploadandDownloadInitiateUploadSingle.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<UploadSingleInitiationResponse>(`${this.configuration.basePath}/upload/single/initiation`,
            uploadSingleInitiationRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
